import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {ListBusState, ServiceParams} from "../../../types";
import {getErrorMessage} from "../../../api";
import {createServiceAPI} from "../../../api/services";
import {setToast} from "../toastNotifySlice";
import {Action, CREATE_ERROR, CREATE_SUCCESS} from "../../../config/message";
import {Toast} from "../../../config/constant";


// @ts-ignore
export const createService = createAsyncThunk('admin/create/service', async (params: ServiceParams, {
    dispatch,
    rejectWithValue
}) => {
    try {
        const response = await createServiceAPI(params);
        const {
            data,
            status
        } = response;
        if (status) {
            dispatch(setCreate({status: status, data: data}));
            dispatch(setToast({
                message: CREATE_SUCCESS(Action.SERVICE),
                status: true,
                type: Toast.TYPE_SUCCESS,
            }))
        }
        return true;
    } catch (error: any) {
        const {response} = error;
        dispatch(setCreateError(response));
        dispatch(setToast({
            message: CREATE_ERROR(Action.SERVICE),
            status: true,
            type: Toast.TYPE_ERROR,
        }))
        return rejectWithValue(getErrorMessage(error));
    }
});
export const createServiceSlice = createSlice({
    name: 'createService',
    initialState: {
        error: false,
        loading: false,
        success: false,
        status: 0,
        message: '',
        errorDetail: null,
    } as ListBusState,
    reducers: {
        setCreate: (state: ListBusState, {payload}) => {

            const {message} = payload.data;
            state.status = payload?.status;
            state.message = message;
        },
        setCreateError: (state: ListBusState, {payload}) => {
            const {errors} = payload.data;
            state.status = payload?.status;
            state.errorDetail = errors;
        },
        resetRegisterCreateService: (state: ListBusState) => {
            state.status = 0;
            state.success = false;
            state.message = '';
            state.errorDetail = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(createService.pending, (state: ListBusState) => {
            state.loading = true;
        });
        builder.addCase(createService.fulfilled, (state: ListBusState) => {
            state.loading = false;
            state.success = true;
            state.error = false;
        });
        builder.addCase(createService.rejected, (state: ListBusState, {payload}) => {
            state.loading = false;
            state.success = false;
            state.error = true;
            state.message = payload;
        });
    },
});

export const createServiceSelector = (state: RootState) => state.createService;
export const {setCreate, setCreateError, resetRegisterCreateService} = createServiceSlice.actions;
